import { Close } from '@components/icons'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

export const FilterPill: FC<{
  label: string
  value: string
  onRemove: VoidFunction
  disabled?: boolean
}> = observer(({ label, onRemove, value, disabled = false }) => (
  <div className="flex items-center rounded-lg bg-black text-xl text-white">
    <p className="px-3 py-2 font-medium">
      {label}:<span className="ml-1 font-thin">{value}</span>
    </p>

    <button
      onClick={onRemove}
      disabled={disabled}
      type="button"
      className={`
        ${
          disabled
            ? `
              cursor-not-allowed
              hover:bg-negative-400/20
            `
            : `
              cursor-pointer
              hover:bg-negative-400/50
            `
        }
        flex h-full items-center justify-center rounded-r-lg bg-black px-2 transition-colors
      `}
    >
      <Close className="h-6 w-6" />
    </button>
  </div>
))
